export default function Tooltip() {
  return {}
}
